import { useQuery } from "@tanstack/react-query";
import { UserService } from "src/services";
import { queryKeys } from "src/constants";
import { useAuthorisation } from "src/context";

const useUserVendorsActivePOIds = (userService: UserService) => {
  const { userRole } = useAuthorisation();

  const {
    data: usersActivePurchaseOrderIds,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.userVendorsActivePOIds(userRole),
    queryFn: () => (userRole === "VENDOR" ? userService.getUserVendorsActivePurchaseOrderIds() : []),
    enabled: !!userRole
  });

  return {
    usersActivePurchaseOrderIds,
    fetchError,
    isLoading,
    refetch
  };
};

export { useUserVendorsActivePOIds };
